import { useTheme, forBrands, css, Theme, SerializedStyles } from '@core-ui/react-stitch';

const getStyles = (): SerializedStyles => {
  const theme: Theme = useTheme();

  const brandSpecificFontColor = forBrands(theme, {
    at: ({ color }: Theme): SerializedStyles => css`color: ${color.b1};`,
    default: ({ color }: Theme): SerializedStyles => css`color: ${color.bk};`
  });

  return css`
    ${theme.brandFont}
    ${brandSpecificFontColor}
    font-size: 120%;
    padding-left: 1rem;
    padding-top: 0.5rem;
  `;
};

export default getStyles;
